import { render, staticRenderFns } from "./AddPointsFinalizeListOfUsers.vue?vue&type=template&id=6e8c2280&scoped=true&"
import script from "./AddPointsFinalizeListOfUsers.vue?vue&type=script&lang=js&"
export * from "./AddPointsFinalizeListOfUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8c2280",
  null
  
)

export default component.exports